import RouterView from '@/page/main/DefaultRouterView'


import Create from '@/page/contract/create'
import List from '@/page/contract/list'
import Detail from '@/page/contract/detail'

import CreateInviteApproval from '@/page/contract/createInviteApproval'
import CreateContractApproval from '@/page/contract/createContractApproval'
import CreateContractRecordApproval from '@/page/contract/CreateContractRecordApproval'

import CreateMoneyApproval from '@/page/contract/createMoneyApproval'
import CreatePayApproval from '@/page/contract/createPayApproval'

import InviteResult from '@/page/contract/inviteResult'

// 合同验收记录
import CreateEnd from '@/page/contract/createEnd'

// 项目废弃审批
import CreateDiscard from '@/page/project/formLayout/createDiscard'

export default {
  path: '/Contract',
  component: RouterView,
  children: [{
    path: 'CreateDiscard',
    meta: {
      type: ['contract', 'list'],
      title: '合同废弃审批'
    },
    component: CreateDiscard
  }, {
      path: 'Create/:objectId?',
      meta: {
        type: ['contract', 'create'],
        title: '新建合同'
      },
      component: Create
    },
    {
      path: 'Edit/:id',
      meta: {
        type: ['contract', 'list'],
        title: '编辑合同'
      },
      component: Create
    },
    {
      path: 'List',
      meta: {
        type: ['contract', 'list'],
        title: '合同列表'
      },
      component: List
    }, {
      path: 'Detail/:id',
      meta: {
        type: ['contract', 'list'],
        title: '合同详情'
      },
      component: Detail
    },

    {
      path: 'CreateInviteApproval/:contractId/:applyId?',
      meta: {
        type: ['contract', 'list'],
        title: '招标文件审核会签'
      },
      component: CreateInviteApproval
    },
    {
      path: 'CreateContractApproval/:contractId/:applyId?',
      meta: {
        type: ['contract', 'list'],
        title: '合同会签'
      },
      component: CreateContractApproval
    },
    {
      path: 'CreateContractRecordApproval/:contractId/:applyId?',
      meta: {
        type: ['contract', 'list'],
        title: '合同备案审批'
      },
      component: CreateContractRecordApproval
    },
    {
      path: 'CreateMoneyApproval/:contractId/:applyId?',
      meta: {
        type: ['contract', 'list'],
        title: '合同支付进度款审批'
      },
      component: CreateMoneyApproval
    },
    {
      path: 'CreatePayApproval/:contractId/:applyId?',
      meta: {
        type: ['contract', 'list'],
        title: '合同支付付款审批'
      },
      component: CreatePayApproval
    },
    {
      path: 'InviteResult/:relateId',
      meta: {
        type: ['contract', 'list'],
        title: '招标情况(开标结果)填录'
      },
      component: InviteResult
    },
    {
      path: 'CreateEnd/:contractId',
      meta: {
        type: ['contract', 'list'],
        title: '合同验收登记'
      },
      component: CreateEnd
    },
  ]
}


// WEBPACK FOOTER //
// ./src/router/contract.js